import { Flex } from 'ui'

import { usePulseContext } from '../../context/PulseProvider'
import { MetricBox } from '../MetricBox'
import { formatCurrency } from 'lib/string'
import { usePayRateMetrics } from 'queries/pulse/usePayRateMetrics'

export function PayRateMetrics() {
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = usePayRateMetrics(filters)

  return (
    <Flex
      flexWrap={'wrap'}
      flexDirection={['column', 'row', 'row']}
      justifyContent="space-between"
      gap={2}
    >
      <MetricBox
        title="Average Pay Rate"
        value={`${formatCurrency(
          data?.avg_pay_rate_with_company_bonus ?? 0
        )} / hr`}
        isLoading={isLoading}
      />
      <MetricBox
        title="Average Base Pay Rate"
        value={`${formatCurrency(data?.avg_pay_rate ?? 0)} / hr`}
        isLoading={isLoading}
      />
      <MetricBox
        title="Average Bonus Rate"
        value={`${formatCurrency(data?.avg_bonus_rate ?? 0)} / hr`}
        isLoading={isLoading}
      />
    </Flex>
  )
}
